import { CheckOutlined, CopyOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { useAppTranslation } from 'app/hooks';
import Typo from 'consts/typography';
import { useState } from 'react';
import QRCode from 'react-qr-code';

interface DepositQrProps {
  address: string;
  symbol: string;
  tag: string;
}

const DepositQr: React.FunctionComponent<DepositQrProps> = (props) => {
  const { address, symbol, tag } = props;

  const t = useAppTranslation();
  const [copyButtonStatus, setCopyButtonStatus] = useState(false);
  const [copyMemmoStatus, setCopyMemmoStatus] = useState(false);

  const handleCopyToClipboard = (text: string, type: 'ADDRESS' | 'MEMO') => {
    navigator.clipboard.writeText(text || '');
    if (type === 'ADDRESS') {
      setCopyButtonStatus(true);
      setTimeout(() => {
        setCopyButtonStatus(false);
      }, 2500);
    } else {
      setCopyMemmoStatus(true);
      setTimeout(() => {
        setCopyMemmoStatus(false);
      }, 2500);
    }
  };

  return (
    <div className="center-content-col gap-3 qr-deposit-container">
      <p className="mb-0 p3  span-link">*{t('vinpay.connectModal.transferNotice')}</p>
      <QRCode viewBox={`0 0 256 256`} size={256} value={address} className="qr-code" />
      <div className="common-input input-address">
        <label className={`${Typo.p4} font-medium primary-text-color`} htmlFor="deposit-address">
          {t('cashier.address')}
        </label>
        <input
          type="text"
          name="deposit-address"
          id="deposit-address"
          autoComplete="off"
          value={address}
          placeholder={t('placeholder.enterDepositAddress')}
          readOnly
        />
        {copyButtonStatus ? (
          <CheckOutlined className="icon-copy" width={20} />
        ) : (
          <CopyOutlined
            className="icon-copy"
            onClick={() => handleCopyToClipboard(address, 'ADDRESS')}
            width={20}
          />
        )}
      </div>
      {!!tag && (
        <div className="common-input input-address">
          <label className={`${Typo.p4} font-medium primary-text-color`} htmlFor="deposit-address">
            Memo
          </label>
          <input
            type="text"
            name="deposit-address"
            id="deposit-address"
            autoComplete="off"
            value={tag}
            placeholder={t('placeholder.enterDepositAddress')}
            readOnly
          />
          {copyMemmoStatus ? (
            <CheckOutlined className="icon-copy" width={20} />
          ) : (
            <CopyOutlined
              className="icon-copy"
              onClick={() => handleCopyToClipboard(tag, 'MEMO')}
              width={20}
            />
          )}
        </div>
      )}

      <ul className="deposite-notes">
        <li className="note">
          <ExclamationCircleOutlined />
          <p className={`${Typo.p4} font-normal`}>
            {t('cashier.note.first', {
              symbol: symbol,
            })}
          </p>
        </li>
        <li className="note">
          <ExclamationCircleOutlined />
          <p className={`${Typo.p4} font-normal`}>{t('cashier.note.second')}</p>
        </li>
        <li className="note">
          <ExclamationCircleOutlined />
          <p className={`${Typo.p4} font-normal`}>{t('cashier.note.third')}</p>
        </li>
      </ul>
    </div>
  );
};

export default DepositQr;
